import { render, staticRenderFns } from "./MinorSidebar.vue?vue&type=template&id=a06b41d8&scoped=true"
import script from "./MinorSidebar.vue?vue&type=script&lang=js"
export * from "./MinorSidebar.vue?vue&type=script&lang=js"
import style0 from "./MinorSidebar.vue?vue&type=style&index=0&id=a06b41d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06b41d8",
  null
  
)

export default component.exports